import { api } from './apiClient.js';

/**
 * Create a new instruction record (first save for an agent without one).
 * POST /v1/instruction/create
 *
 * @param {{ instruction_text: string }} body
 * @returns {Promise<unknown>}
 */
export const createInstruction = (body) => api.post('/v1/instruction/create', body);

/**
 * Update instruction text for an existing instruction UUID.
 * POST /v1/instruction/:uuid/update
 *
 * @param {string} uuid
 * @param {{ instruction_text: string }} body
 * @returns {Promise<unknown>}
 */
export const updateInstruction = (uuid, body) =>
  api.post(`/v1/instruction/${uuid}/update`, body);
